<template>
    <div class="collection-item-box" @click="$modal.open('product', product)">
        <h2 class="truncate" v-text="product.name"></h2>
        <p> {{ product.family ? product.family.name : '-'}}</p>
        <hr>
        <div class="flex justify-between items-center">
          <div>
            <vue-tag :class="stockClass" icon="cupcake-solid">
              {{ product.stock !== null ? product.stock : '-' }}
            </vue-tag>
            <vue-tag v-if="!product.active" class="bg-red-lightest text-red-light" icon="hide-password-solid"></vue-tag>
          </div>
          <vue-tag icon="card-stack-view-solid">
            {{ product.pack_alone ? 'Seul' : 'Plusieurs'}}
          </vue-tag>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
  },

  computed: {
    stockClass() {
      switch (this.product.stock_status) {
        case null:
          return '';
        case 'very-low':
          return 'bg-red-lightest text-red-light';
        case 'low':
          return 'bg-orange-lightest text-orange';
        case 'normal':
          return 'bg-green-lightest text-green-light';
        default:
          return '';
      }
    },
  },
};
</script>